import { lazy } from 'react';

import { retry } from 'app/utils/lib/file';

type ComponentProps = Record<string, unknown>;

const LazyAdminActionsRoute = lazy(() => retry(() => import('app/pages/admin/AdminActions')));
const LazyAdminCompanyDetailsRoute = lazy(() =>
  retry(() => import('app/pages/admin/AdminActions/CompanyDetails')));
const LazyCsrDashboardRoute = lazy(() =>
  retry(() => import('app/pages/admin/AdminActions/CsrDashboard')));
const LazyCreditLimitExceededRoute = lazy(() =>
  retry(() => import('app/pages/admin/AdminActions/CreditLimitExceeded')));
const LazyCreditLimitExposureRoute = lazy(() =>
  retry(() => import('app/pages/admin/AdminActions/CreditLimitExposure')));
const LazyInvoicePayDateChangeIndexReportRoute = lazy(() =>
  retry(() => import('app/pages/admin/AdminActions/InvoicePayDateChangeIndexReport')));
const LazyInvoicePayDateChangeShowReportRoute = lazy(() =>
  retry(() => import('app/pages/admin/AdminActions/InvoicePayDateChangeShowReport')));
const LazyFactorAssignmentRoute = lazy(() =>
  retry(() => import('app/pages/admin/AdminActions/FactorAssignment')));
const LazyAdminFactorAssignmentAuditRoute = lazy(() =>
  retry(() => import('app/pages/admin/AdminActions/FactorAssignment/AdminFactorAssignmentAudit')));
const LazyAdminFactorAssignmentHistoryRoute = lazy(() =>
  retry(() => import('app/pages/admin/AdminActions/FactorAssignment/AdminFactorAssignmentHistory')));

export const AdminActions = (props: ComponentProps) => <LazyAdminActionsRoute {...props} />;
export const AdminCompanyDetails = (props: ComponentProps) => <LazyAdminCompanyDetailsRoute {...props} />;
export const CsrDashboard = (props: ComponentProps) => <LazyCsrDashboardRoute {...props} />;
export const CreditLimitExceeded = (props: ComponentProps) => <LazyCreditLimitExceededRoute {...props} />;
export const CreditLimitExposure = (props: ComponentProps) => <LazyCreditLimitExposureRoute {...props} />;
export const InvoicePayDateChangeIndexReport = (props: ComponentProps) =>
  <LazyInvoicePayDateChangeIndexReportRoute {...props} />;
export const InvoicePayDateChangeShowReport = (props: ComponentProps) =>
  <LazyInvoicePayDateChangeShowReportRoute {...props} />;
export const FactorAssignment = (props: ComponentProps) => <LazyFactorAssignmentRoute {...props} />;
export const AdminFactorAssignmentAudit = (props: ComponentProps) =>
  <LazyAdminFactorAssignmentAuditRoute {...props} />;
export const AdminFactorAssignmentHistory = (props: ComponentProps) =>
  <LazyAdminFactorAssignmentHistoryRoute {...props} />;
